import { v4 as uuidv4 } from 'uuid';

export interface IOverviewConfig {
    id?: string;
    title: string;
    value: number;
    onClick: () => void;
}

export class OverviewConfig {
    id: string;
    title: string;
    value: number;
    onClick: () => void;

    constructor(options: IOverviewConfig) {
        this.id = options.id ?? uuidv4();
        this.title = options.title;
        this.value = options.value;
        this.onClick = options.onClick;
    }
}